<template>
  <div>
    <!-- <div class="vld-parent mycenter">
      <loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
  </div> -->
    <DormList :dorms="dorms" v-if="dorms" />
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
    <FixedPopup
      :dorms="popupDorms"
      v-if="popupDorms && popupDorms.length > 0"
    />
    <ContentLoader v-if="!dorms && !this.$helpers.mobileCheck" :height="900">
      <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
      <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
      <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
      <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />
    </ContentLoader>

    <ContentLoader v-if="!popupDorms && this.$helpers.mobileCheck">
      <rect x="3" y="0" rx="3" ry="3" width="376" height="800" />
    </ContentLoader>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import InfiniteLoading from 'vue-infinite-loading'
// import Loading from 'vue-loading-overlay'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import { ContentLoader } from 'vue-content-loader'
import { mapGetters } from 'vuex'

export default {
  name: 'CityMain',
  components: {
    DormList,
    InfiniteLoading,
    // Loading,
    FixedPopup,
    ContentLoader
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.cityDetails ? this.cityDetails.title : '',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.cityDetails ? this.cityDetails.description : ''
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.cityDetails ? this.cityDetails.keywords : ''
        }
      ],
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: window.location.origin + this.fullPath
        }
      ]
    }
  },
  data() {
    return {
      fullPath: '',
      url: '',
      isLoading: false,
      fullPage: true,
      page: 2,
      dorms: null,
      pagination: null,
      popupDorms: null,
      emptyContent: {
        icon: 'icon-search',
        title: 'Sonuç Bulunamadı!',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      }
    }
  },
  methods: {
    infiniteHandler($state) {
      let self = this
      axios
        .get(`/site/cities/dorms/${this.$route.params.city}?page=${this.page}`)
        .then(response => {
          if (response.data.data.data) {
            this.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (
              Array.isArray(self.dorms) &&
              Array.isArray(response.data.data.data) !== true &&
              Object.keys(response.data.data.data).length !== 0
            ) {
              Object.keys(response.data.data.data).forEach(item => {
                self.dorms.push(response.data.data.data[item])
              })
              self.popupDorms = response.data.popups
              $state.loaded()
            } else {
              $state.complete()
            }
          }
        })
    },
    getDorms() {
      let self = this
      this.isLoading = true
      const page = this.$route.params.page ? this.$route.params.page : 1
      axios
        .get(`/site/cities/dorms/${this.$route.params.city}?page=${page}`)
        .then(response => {
          // self.pagination = response.data.data
          this.isLoading = false
          self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['cityDetails'])
  },
  mounted() {
    this.getDorms()
  },
  created() {
    var myString = this.$route.fullPath
    var lastChar = myString[myString.length - 1]

    if (lastChar === '/') {
      this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }
  },
  watch: {
    $route() {
      this.getDorms()
      this.url = window.location.origin + this.$route.fullPath
    }
  }
}
</script>

<style scoped>
.mycenter {
  display: table;
  margin: 0 auto;
}
</style>
